module.exports = __webpack_public_path__ + "static/stimpack-logo-meta-image-min-9c89d28d9b733c2fc50ba7dfcfc50073.jpg";